export default theme => ({
	bodyStyle: {},
});
